export default __webpack_public_path__ + "static/media/coachingReports.abb7e655.svg";